import LandingPage from "@/components/LandingPage.vue";
import THOC from "@/views/THOCView.vue";
import TSD from "@/views/TSDView.vue";
import SMAPOY from "@/views/SMAPOYView.vue";
import Features from "@/components/Features.vue";
import Contact from "@/components/Contact.vue";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  scrollBehavior() {
    return { top: 0 };
  },
  history: createWebHistory(),
  routes: [
    { path: "/", name: "Home", component: LandingPage },
    { path: "/books/thoc", name: "THOC", component: THOC },
    { path: "/books/tsd", name: "TSD", component: TSD },
    { path: "/books/smapoy", name: "SMAPOY", component: SMAPOY },
    { path: "/features", name: "Features", component: Features },
    { path: "/contact", name: "Contact", component: Contact },
  ],
});

export default router;
